export type GranularPermission = 'audio' | 'photo' | 'video';
